import React from 'react'
import defaultClasses from './testimonialsSlide.module.scss'
import { string } from 'prop-types'

const TestimonialSlide = (props) => {
    const { header, content, name, city } = props

    return (
        <div className={defaultClasses['testimonial-slide']}>
            <div className={defaultClasses['testimonial-slide-subtitle']}>
                {header}
            </div>
            <div
                className={defaultClasses['testimonial-slide-text']}
                dangerouslySetInnerHTML={{ __html: content }}
            />
            <div className={defaultClasses['testimonial-slide-bottom']}>
                <div
                    className={defaultClasses['testimonial-slide-bottom-name']}
                >
                    {name}
                </div>
                <div
                    className={
                        defaultClasses['testimonial-slide-bottom-location']
                    }
                >
                    {city}
                </div>
            </div>
        </div>
    )
}

TestimonialSlide.propTypes = {
    header: string,
    content: string,
    name: string,
    city: string
}

export default TestimonialSlide
